import { Injectable } from '@angular/core';
import { from, Subject, concat } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';

import { DeviceSettings } from './deviceSettings';
import { Logger } from './logger';

@Injectable({
    providedIn: "root"
})
export class VolumeSettingWatcher {
    readonly volumeSettingSubject = new Subject<number>(); 

    private setVolume(v: number) : void {
        if (window.tizen && tizen.tvaudiocontrol && tizen.tvaudiocontrol.setVolume) {
            try {
                tizen.tvaudiocontrol.setVolume(v);
            } catch (e) {
                this.log.error('VolumeSettingWatcher', `Execption thrown from VolumeSettingsWatcher.setVolume(${v})`, e);
            }
        } else {
            console.log(`VolumeSettingWatcher.setVolume(${v}). Tizen method unavailable`);
        }
    }

    constructor(private readonly deviceSettings: DeviceSettings, private readonly log : Logger) {
    }


    startWatching() {
        concat(
            from(this.deviceSettings.getPlayerSettings()),
            this.deviceSettings.playerSettingsObservable
        ).pipe(
            map(s => s.audioVolume),
            distinctUntilChanged()
        ).subscribe(
            v => this.setVolume(v)
        );
    }
}